import { useQuery } from '@tanstack/react-query'
import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { InterestCodesType } from './types'
import dayjs from 'dayjs'

const fetchInterestCode = async (policyNumber: string, treatmentDateIn: Dayjs | string) => {
  const response = await httpClientPrivate.get<InterestCodesType>(
    `${config.restUrl}/v1/backoffice/health-claim/interest-code/${policyNumber}`,
    {
      params: {
        treatmentDateIn: treatmentDateIn ? dayjs(treatmentDateIn).toISOString() : undefined,
      },
    },
  )

  return response.data
}

const useInterestCode = (policyNumber: string, treatmentDateIn: Dayjs | string) => {
  const queryKey = ['useInterestCode', policyNumber, treatmentDateIn]
  const queryFn = async () => fetchInterestCode(policyNumber, treatmentDateIn)
  const queryResult = useQuery({ queryKey, queryFn, enabled: !!policyNumber })

  return { ...queryResult }
}

export { fetchInterestCode, useInterestCode }
